export const DatabaseTypes = {
  DATABASE: "database",
};
